// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2THWX","select":"Header_select__2PYdX","clinic":"Header_clinic__3Rrnh"};